import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IOfferCreateAddress {
    houseId?: number,
    unifiedHouseId?: number,
    office: string,
    companyId: number,
}

export interface IOfferCreatePersonalInformation {
    clientName: string,
    clientPhone: string,
    clientPhoneExtra?: string,
    passportNumber?: string,
    whoIssue?: string,
    dateIssue?: string,
    birthplace?: string,
    birthdate?: string,
    registrationArea?: string,
    registrationStreet?: string,
    registrationHouse?: number,
    registrationBuilding?: string,
    registrationOffice?: string,
}

export interface IOfferCreateTariff {
    tariffId: number,
    tariffIdDmf?: number,
    createConnectDmf?: boolean,
    connectPhone?: string,
    tarifPlanVc?: string,
    connectPlanVc?: string,
}

export interface IOfferCreateItem {
    id: number,
    type: string,
    count?: number,
    duration?: number,
    equipTestdrive?: boolean,
}

export interface IOfferCreateRequestDto {
    address: IOfferCreateAddress,
    personalInformation: IOfferCreatePersonalInformation,
    tariff: IOfferCreateTariff,
    promocodeName?: string,
    comment?: string,
    analyticsId?: string,
    selfactivation?: number,
    selfactivationWithEquip?: number,
    items?: IOfferCreateItem[],
    managerId?: number,
}

export interface IOfferCreateResponseDto {
    message: string,
    agreementNumber: string,
    agreementId: string,
    isDouble: boolean,
    fromCache: boolean,
    promoBonusType?: number,
    promoBonusSum?: number,
    promoBonusDate?: string,
    bonusWelcome?: number,
    bonusWelcomeDate?: string,
    plbRegistrationSuccessful?: boolean,
    promoCodeSuccessful?: boolean,
}

/* Запрос на создание договора v2
https://master.full-buy.sandbox.d2c.r-one.io/docs/#/Agreement/AgreementController_offerCreateV2 */
export const offerCreate = (providerId: number, requestDto: IOfferCreateRequestDto): IRequest => ({
    uri: `/v2/${providerId}/agreement/offer-create`,
    method: 'POST',
    body: JSON.stringify(requestDto),
    withProvider: true,
});
